import { Injectable, InjectionToken, Injector } from '@angular/core';
import { GlobalPermissions, toAppAuthorization } from './shared-module/configs/permission-configs';

@Injectable({
  providedIn: 'root'
})
export class AppInjectorService {

  private static injector: Injector;

  static setInjector(injector: Injector) {

    AppInjectorService.injector = injector;

  }

  static getInjector(): Injector {

    return AppInjectorService.injector;

  }
}

export interface AppAuthorization {
  userRolesAny?: string[];
  permissions?: string[];
}

const defaultAppAuthorization: AppAuthorization = toAppAuthorization(GlobalPermissions.MARKETING_MANAGEMENT);

export const APP_AUTHORIZATION = new InjectionToken<AppAuthorization>('Provide authorization at component level.',
  {
    factory: () => {
      // you can use inject(SomeService) on that function
      return defaultAppAuthorization;
    }
  });
